import { render, staticRenderFns } from "./c_is_show.vue?vue&type=template&id=6a0b99b5&scoped=true"
import script from "./c_is_show.vue?vue&type=script&lang=js"
export * from "./c_is_show.vue?vue&type=script&lang=js"
import style0 from "./c_is_show.vue?vue&type=style&index=0&id=6a0b99b5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b99b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0b99b5')) {
      api.createRecord('6a0b99b5', component.options)
    } else {
      api.reload('6a0b99b5', component.options)
    }
    module.hot.accept("./c_is_show.vue?vue&type=template&id=6a0b99b5&scoped=true", function () {
      api.rerender('6a0b99b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_is_show.vue"
export default component.exports